import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import DetailRow from "../CustomComponents/DetailRow";
import UserAvatar from "../CustomComponents/UserAvatar";

const DetailUserModal = ({ handleEditModalClose, editData }) => {
  const [mounted, setMounted] = React.useState(false);

  console.log(editData);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <ModalContainer handleClose={handleEditModalClose}>
      <div className={cssStyles.modalContainer} style={{ maxWidth: "80%" }}>
        {/* Header */}
        <div className="d-flex align-items-center w-100 justify-content-between mb-4">
          <p className="fs-4 fw-medium m-0 ">User Details</p>
          <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
            <FaCircleXmark
              role="button"
              onClick={handleEditModalClose}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>

        {/* Body */}
        <div className="w-100">
          <Row className="g-5">
            {/* Left Side */}
            <Col sm={12} md={6}>
              <div className="d-flex flex-column align-items-center mb-4">
                <UserAvatar
                  image_url={editData?.image_url}
                  username={`${editData?.firstname} ${editData?.lastname}`}
                  size={90}
                />
                <p className="fw-bold mt-2">
                  {editData?.firstname} {editData?.lastname}
                </p>
              </div>

              <DetailRow title="Username" value={editData?.username} />
              <DetailRow title="Email" value={editData?.email} />
              <DetailRow title="Phone" value={editData?.mobile_no} />
              <DetailRow title="Country" value={editData?.country} />
              <DetailRow title="City" value={editData?.city} />
              <DetailRow title="Location" value={editData?.location} />
            </Col>

            {/* Right Side */}
            <Col sm={12} md={6}>
              <DetailRow
                title="Wallet Amount"
                value={`$${editData?.wallet_amount}`}
              />
              <DetailRow
                title="Stripe Customer ID"
                value={editData?.stripe_customer_id || "N/A"}
              />
              <DetailRow
                title="Stripe Connect"
                value={editData?.stripe_connect_account_id || "Not Connected"}
              />
              <DetailRow
                title="Transfer Capabilities"
                value={editData?.transfer_capabilities ? "Enabled" : "Disabled"}
              />
              <DetailRow
                title="Push Notifications"
                value={editData?.push_notification ? "On" : "Off"}
              />
              <DetailRow
                title="Status"
                value={editData?.is_blocked ? "Blocked" : "Active"}
              />
            </Col>
          </Row>
        </div>
      </div>
    </ModalContainer>
  );
};

export default DetailUserModal;
